if (!customElements.get('ds-media-with-text')) {
  class DsMediaWithText extends HTMLElement {
    constructor() {
      super();

      this.selectors = {
        swiper: '.ds-mwt__slider',
        prev: '[data-ds-mwt-prev]',
        next: '[data-ds-mwt-next]',
        pagination: '[data-ds-mwt-pagination]',
        toggle: '[data-ds-mwt-toggle]',
        videos: '.ds-mwt__video',
      };

      this.swiper = null;
      this.initSlider();
      this.initMediaToggle();
    }

    initSlider() {
      const swiperEl = this.querySelector(this.selectors.swiper);
      if (!swiperEl) return;

      if (!window.Swiper) {
        return setTimeout(() => this.initSlider(), 100);
      }

      const autoplayEnabled = swiperEl.dataset.autoplay === 'true';
      const autoplaySpeed = parseInt(swiperEl.dataset.autoplaySpeed, 10) || 5000;
      const gotoSlideTemplate = this.dataset.labelGotoSlide || 'Go to slide %INDEX%';

      const swiperConfig = {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        speed: 600,
        watchSlidesProgress: true,
        a11y: {
          enabled: true,
          containerMessage: this.querySelector(this.selectors.swiper)?.getAttribute('aria-label') || undefined,
        },
        navigation: {
          prevEl: this.querySelector(this.selectors.prev),
          nextEl: this.querySelector(this.selectors.next),
        },
        pagination: {
          el: this.querySelector(this.selectors.pagination),
          clickable: true,
          bulletClass: 'ds-mwt__dot',
          bulletActiveClass: 'is-active',
          renderBullet: function (index, className) {
            const label = gotoSlideTemplate.replace('%INDEX%', index + 1);
            return '<button type="button" class="' + className + '" aria-label="' + label + '"></button>';
          },
        },
        autoplay: autoplayEnabled
          ? {
              delay: autoplaySpeed,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }
          : false,
      };

      this.swiper = new window.Swiper(swiperEl, swiperConfig);
    }

    getVideos() {
      return Array.from(this.querySelectorAll(this.selectors.videos));
    }

    playVideos() {
      this.getVideos().forEach((video) => {
        const playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => {});
        }
      });
    }

    pauseVideos() {
      this.getVideos().forEach((video) => {
        video.pause();
      });
    }

    initMediaToggle() {
      const toggle = this.querySelector(this.selectors.toggle);
      if (!toggle) return;

      const labelPlay = this.dataset.labelPlay || 'Play';
      const labelPause = this.dataset.labelPause || 'Pause';
      const hasSlider = !!this.querySelector(this.selectors.swiper);
      const initialState = toggle.dataset.state === 'paused' ? 'paused' : 'playing';

      const setState = (state) => {
        const isPlaying = state === 'playing';
        toggle.dataset.state = state;
        toggle.setAttribute('aria-pressed', isPlaying ? 'false' : 'true');
        toggle.setAttribute('aria-label', isPlaying ? labelPause : labelPlay);

        if (hasSlider && this.swiper) {
          if (isPlaying) {
            if (this.swiper.autoplay && this.swiper.params.autoplay) {
              this.swiper.autoplay.start();
            }
            this.playVideos();
          } else if (this.swiper.autoplay) {
            this.swiper.autoplay.stop();
            this.pauseVideos();
          }
        } else if (isPlaying) {
          this.playVideos();
        } else {
          this.pauseVideos();
        }
      };

      setState(initialState);

      toggle.addEventListener('click', () => {
        setState(toggle.dataset.state === 'playing' ? 'paused' : 'playing');
      });
    }
  }

  customElements.define('ds-media-with-text', DsMediaWithText);
}
